import { Qr } from 'component/Qr'
import { useEffectOnce } from 'hook/useEffectOnce'
import { observer } from 'mobx-react-lite'
import { me } from 'store/me'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { Photo } from 'type/Options'
import { omit } from 'util/object'

type Props = {
  size: number
  photo?: Photo
  onDone: () => void
}

function buildLink(photo: Photo | undefined) {
  const params = new URLSearchParams(omit({
    user: me.user_id,
    product: opt.options.product,
    identity: store.profile?.identity_id || undefined,
  }))

  // У фото в полный рост своя страница, остальные типы забирает страница селфи.
  const path = photo === 'full' ? '/fullbody' : '/selfie'
  const host = location.origin
  return `${host}${path}?${params}`
}

export const UploadQr = observer(({ size, photo, onDone }: Props) => {
  // По умолчанию ведём на тот же тип фото, который выбран в профиле на панели.
  const link = buildLink(photo ?? store.profile?.type)

  useEffectOnce(() => {
    // Ждём именно тот снимок, который грузят с телефона: для фото в полный рост
    // селфи не меняется, и опрос по нему не заканчивался никогда.
    const full = (photo ?? store.profile?.type) === 'full'
    const current = () => full ? store.profile?.common.userPhoto.url : store.profile?.picture
    const initial = current()

    let stopped = false
    let timeout_id: ReturnType<typeof setTimeout>

    async function update() {
      try {
        await store.identities.update()
      } catch (e) {
        // Сетевая ошибка не должна убивать опрос: иначе фото с телефона уже не долетит.
        console.error('identity update failed', e)
      }
      if (stopped) return
      if (current() !== initial) onDone()
      else timeout_id = setTimeout(update, 1000)
    }

    timeout_id = setTimeout(update, 1000)

    return () => {
      stopped = true
      clearTimeout(timeout_id)
    }
  })

  return <Qr link={link} size={size} pad={16} />
})
